import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import isMoment from 'utils/predicates/isMoment.util';

const isValidDateMoment = (value) => fromAnyToBool(value && isMoment(value) && value.isValid());

export default isValidDateMoment;
